import { Button, Divider, Form, Input, Modal, Space, Tabs } from "antd"
import styled from "styled-components"
import ImageTabRightPromptLastestPrompt from "./ImageTabRightPromptLastestPrompt";
import ImageTabRightPromptLastestCondition from "./ImageTabRightPromptLastestCondition";
import ImageTabRightPromptNewCondition from "./ImageTabRightPromptNewCondition";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const StyledSpace = styled((props)=><Space direction="vertical" size={0} {...props}/>)`
  &&& {
    display: flex;
    flex-direction: column;
    flex-grow:1;
    overflow: auto;

    & > .ant-space-item:nth-child(1) {
      overflow: auto;
    }
  }
`

const backend = process.env.REACT_APP_BACKEND


function ImageTabRightPrompt({prompt, rightBox, stateHandler, gptModel}) {
  const promptRef = useRef()
  const [promptData, setPromptData] = useState([])
  const [curTab, setCurTab] = useState("itme-1")
  const navigate = useNavigate()

  const promptDataHandler = (newData) => {
    setPromptData(newData)
  }

  const tabChangeHandler = (_) => {
    setCurTab(_)
  }

  const items = [
    { label: "신규 프롬프트 생성", key: "item-1", style: { height: "100%", overflow: "auto" }, children: <ImageTabRightPromptNewCondition prompt={prompt} rightBox={rightBox} stateHandler={stateHandler} ref={promptRef} promptDataHandler={promptDataHandler} gptModel={gptModel}/> }, // remember to pass the key prop
    { label: "마지막으로 저장된 조건", key: "item-2", style: { height: "100%", overflow: "auto" }, children: <ImageTabRightPromptLastestCondition prompt={prompt} rightBox={rightBox} stateHandler={stateHandler} ref={promptRef} promptDataHandler={promptDataHandler} gptModel={gptModel}/>},
    { label: "마지막으로 저장된 프롬프트", key: "item-3", style: { height: "100%", overflow: "auto" }, children: <ImageTabRightPromptLastestPrompt rightBox={rightBox} ref={promptRef}/> },
  ];


  const promptConditionSaveHandler = () => {
    const WordExMaster_id = rightBox[1].id

    axios
    .post(`${backend}/contents/new_word/image/last_condition/${WordExMaster_id}`,{promptData})
    .then(res=>{
      Modal.success({
        title:"저장완료",
        okText:"확인",
      })
    })
    .catch(err=>{
      console.log(err);
      Modal.error({
        title:"저장에러",
        content:"저장하지 못했습니다. console을 확인하세요.",
        okText:"확인"
      })
      if(err.response && err.response.status===401) {
        navigate("/auth")
      }
    })
  }



  const promptSentenceSaveHandler = () =>{
    const WordExMaster_id = rightBox[1].id
    const promptSentence = promptRef.current.getFieldValue("prompt_text")

    axios
      .post(`${backend}/contents/new_word/image/last_prompt/${WordExMaster_id}`,{promptSentence})
      .then(res=>{
        const instance = {...rightBox[1]}
        instance.final_prompt = promptSentence

        stateHandler("sourceDataForRightBox", instance)
        stateHandler("rightBox", [true, instance])

        Modal.success({
          title:"저장완료",
          okText:"확인",
        })
      })
      .catch(err=>{
        console.log(err);
        Modal.error({
          title:"저장에러",
          content:"저장하지 못했습니다. console을 확인하세요.",
          okText:"확인"
        })
        if(err.response && err.response.status===401) {
          navigate("/auth")
        }
      })
  }

  return (
    <div style={{height:"100%", display:"flex"}}>
      <StyledSpace>
        <Tabs items={items} destroyInactiveTabPane={true} size={"small"} onChange={tabChangeHandler} style={{flexGrow:1, overflow:"auto"}} type="line"></Tabs>
        <Space size={0} style={{width:"100%", justifyContent:"right"}}>
          <Button size="small" style={{margin:"5px"}} hidden={curTab === "item-3"} onClick={promptConditionSaveHandler}>조건저장</Button>
          <Button size="small" onClick={promptSentenceSaveHandler}>프롬프트 문장 저장</Button>
        </Space>
      </StyledSpace>
    </div>
  )
}

export default ImageTabRightPrompt